module.exports = __webpack_public_path__ + "692012de.svg";